module.exports = __webpack_public_path__ + "static/media/LATMALCOTKITX2.3e474620.png";